export default __webpack_public_path__ + "static/media/15.03259bf4.png";